import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppStore } from '../stores/useAppStore'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isTokenExpired, logout } = useAppStore()

  // Check if user is authenticated and token is not expired
  if (!isAuthenticated() || isTokenExpired()) {
    // If token is expired, logout the user
    if (isTokenExpired()) {
      logout()
    }
    
    // Redirect to login page
    return <Navigate to="/login" replace />
  }

  // User is authenticated, show the protected content
  return <>{children}</>
}

export default ProtectedRoute 